import { createNativeStackNavigator } from "@react-navigation/native-stack";

export const StorecastShowFileNavigator =
  createNativeStackNavigator<StorecastShowFileParamList>();

export type StorecastShowFileParamList = {
  StorecastShowFileScreen: object;
  StorecastShowFileAllFiles: object;
};
